export const BUTTON_PROPS = {
  id: 'account-settings-footer-update',
  icon: 'check',
  left: true,
  submit: true,
  label: 'Update',
};
